import { cx } from './hooks';

/** Inline stroke icons, 24x24 grid, 2px round stroke. `flip` icons mirror under dir=rtl (CSS). */
const P = {
  calendar: 'M7 3.5v3M17 3.5v3M3.5 10h17M7 5h10a3.5 3.5 0 0 1 3.5 3.5v8A3.5 3.5 0 0 1 17 20H7a3.5 3.5 0 0 1-3.5-3.5v-8A3.5 3.5 0 0 1 7 5z',
  users: 'M9 11.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zM2.8 20c.3-3.3 2.8-5.3 6.2-5.3s5.9 2 6.2 5.300M16.5 4.800a3.2 3.2 0 0 1 0 6.200M18 14.900c1.9.6 3.1 2.2 3.3 4.6',
  user: 'M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM4.5 20.500c.4-3.6 3.4-5.5 7.5-5.500s7.1 1.9 7.5 5.5',
  chat: 'M7 4h10a3.5 3.5 0 0 1 3.5 3.500v6A3.5 3.5 0 0 1 17 17h-5.500L7 20.500V17a3.5 3.5 0 0 1-3.5-3.500v-6A3.5 3.5 0 0 1 7 4z',
  chart: 'M5 20v-6M12 20V5M19 20v-9',
  plus: 'M12 5v14M5 12h14',
  minus: 'M5 12h14',
  check: 'M5 12.500l4.5 4.500L19 7.5',
  x: 'M6 6l12 12M18 6L6 18',
  clock: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM12 7.500V12l3 2',
  pin: 'M12 21s6.5-5.7 6.5-11.200a6.5 6.5 0 0 0-13 0C5.5 15.3 12 21 12 21zM12 12.200a2.4 2.4 0 1 0 0-4.8 2.4 2.4 0 0 0 0 4.800z',
  phone: 'M5.5 4h3l1.7 4.3-2 1.300a11 11 0 0 0 5.2 5.200l1.3-2 4.3 1.700v3A2 2 0 0 1 17 19.5 14.5 14.5 0 0 1 4 6.5 2 2 0 0 1 5.5 4z',
  share: 'M6 14.500a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zM18 8.500a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zM18 20.500a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zM8.2 10.800l7.6-4.300M8.2 13.200l7.6 4.3',
  qr: 'M4 4h6v6H4zM14 4h6v6h-6zM4 14h6v6H4zM14 14h2.500v2.500H14zM20 14v2.500M17.5 20H20v-1.500M14 20h.01',
  settings: 'M4 7h9M19 7h1M4 17h1M11 17h9M16 9.500a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zM8 19.500a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z',
  bell: 'M6 16.500V11a6 6 0 0 1 12 0v5.500l1.5 2h-15zM10 21h4',
  trash: 'M4 7h16M9.5 7V4.500h5V7M6.5 7l.8 12.500h9.400L17.5 7M10 11v5M14 11v5',
  undo: 'M9 5L4 10l5 5M4.5 10H14a6 6 0 0 1 0 12h-2',
  'arrow-start': 'M19 12H5M11 6l-6 6 6 6',
  'arrow-end': 'M5 12h14M13 6l6 6-6 6',
  'chevron-start': 'M15 6l-6 6 6 6',
  'chevron-end': 'M9 6l6 6-6 6',
  search: 'M11 17.500a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13zM16 16l4.5 4.5',
  star: 'M12 3.500l2.6 5.4 5.9.8-4.3 4.1 1 5.900L12 17l-5.2 2.7 1-5.900L3.5 9.700l5.9-.8z',
  link: 'M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.700l-1 1M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.700l1-1',
  copy: 'M11 9h7a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2h-7a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2zM15 9V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h3',
  lock: 'M8 11V8a4 4 0 0 1 8 0v3M7 11h10a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2z',
  info: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM12 11v5M12 8v.01',
  alert: 'M12 3.800L2.8 19.500a1 1 0 0 0 .9 1.500h16.600a1 1 0 0 0 .9-1.500zM12 10v4.500M12 17.500v.01',
  home: 'M4 11l8-7 8 7M6 9.500V19a1 1 0 0 0 1 1h3.500v-5.500h3V20H17a1 1 0 0 0 1-1V9.5',
  card: 'M5.5 5.500h13A2.5 2.5 0 0 1 21 8v8a2.5 2.5 0 0 1-2.5 2.500h-13A2.5 2.5 0 0 1 3 16V8a2.5 2.5 0 0 1 2.5-2.500zM3 10h18',
  'check-circle': 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM8 12.200l2.8 2.800L16 9.5',
  'x-circle': 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM9 9l6 6M15 9l-6 6',
  edit: 'M4 20h4l10.5-10.500a2.1 2.1 0 0 0-3-3L5 17zM13.5 7.500l3 3',
  more: 'M5 12h.01M12 12h.01M19 12h.01',
  hourglass: 'M7 3.500h10M7 20.500h10M8 3.500c0 4 4 5 4 8.500s-4 4.5-4 8.500M16 3.500c0 4-4 5-4 8.500s4 4.5 4 8.5',
  globe: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM3 12h18M12 3c3 3 3 15 0 18M12 3c-3 3-3 15 0 18',
  sun: 'M12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM12 2.500v2M12 19.500v2M2.500 12h2M19.500 12h2M5.300 5.300l1.400 1.400M17.300 17.300l1.400 1.400M5.300 18.700l1.400-1.400M17.300 6.700l1.400-1.400',
  timer: 'M12 21a8 8 0 1 0 0-16 8 8 0 0 0 0 16zM12 9v4l2.500 1.500M9.500 2.500h5',
  wallet: 'M4 7.500A2.500 2.500 0 0 1 6.500 5H18v3M4 7.500V17a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2H6.500A2.500 2.500 0 0 1 4 7.500zM16 13.500h.01',
  sparkle: 'M12 3l1.8 5.200L19 10l-5.2 1.800L12 17l-1.8-5.200L5 10l5.2-1.800zM19 16l.7 2 2 .7-2 .7-.7 2-.7-2-2-.7 2-.7z',
} as const;

export type IconName = keyof typeof P;
export const ICON_NAMES = Object.keys(P) as IconName[];
// Directional icons that must mirror in RTL
const FLIP = new Set<string>(['arrow-start', 'arrow-end', 'chevron-start', 'chevron-end', 'undo']);

export interface IconProps {
  name: IconName;
  size?: number;
  /** Stroke width in 24px units. Default 2. */
  stroke?: number;
  /** Accessible name. Omit for decorative icons (aria-hidden). */
  title?: string;
  className?: string;
  filled?: boolean;
}

export function Icon({ name, size = 22, stroke = 2, title, className, filled }: IconProps) {
  const d = P[name];
  return (
    <svg
      className={cx('pl-icon', FLIP.has(name) && 'pl-icon--flip', className)}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={filled ? 'currentColor' : 'none'}
      stroke="currentColor"
      strokeWidth={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      role={title ? 'img' : undefined}
      aria-label={title}
      aria-hidden={title ? undefined : true}
      focusable="false"
    >
      <path d={d} />
    </svg>
  );
}
